import gql from 'graphql-tag';

export default gql`
  mutation setHasOptedOutOfAvailabilityEmails($input: setHasOptedOutOfAvailabilityEmailsInput!) {
    setHasOptedOutOfAvailabilityEmails(input: $input) {
      viewer {
        id
        userSettings {
          repVisits {
            hasOptedOutOfAvailabilityEmails
          }
        }
      }
    }
  }
`;
